<template>
  <div class="ots-pageination" v-if="pagination.total > 0">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.page"
      :page-sizes="[10, 20, 50, 100, 500]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'OtsPagination',
    props: {
      /* ** 2022年10月13日14:58:52 ( current-page 绑定值 currentPage -> pagination.page) ** */
      pagination: {
        type: Object,
        default: () => ({
          total: 0,
          page: 1,
          size: 10,
        })
      },
    },
    data() {
      return {
        currentPage: 1
      };
    },
    mounted() {
      this.$event.$on('setCurrentPage', this.setCurrentPage);
    },
    methods: {
      setCurrentPage(p) {
        this.currentPage = p
      },
      handleSizeChange(num) {
        this.$emit('changeNum', num)
      },
      handleCurrentChange(p) {
        this.$emit('changePage', p)
      }
    },
  };
</script>

<style lang="less" scoped>
  .ots-pageination {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
  .el-pagination {
    /deep/ .is-in-pagination {
      .el-input__inner {
        padding: 0 3px !important;
        width: 100%;
        height: 28px;
        line-height: 28px;
        
      }
    }
    /* 表单设置统一样式 */
    /deep/ .el-input {
      height: 28px;
      line-height: 28px;
      .el-input__inner {
        padding: 0 13px 0 3px !important;

        box-sizing: border-box;
        width: 100%;
        height: 28px;
        line-height: 28px;
      }
    }
  }
  /* 选中 type="number" 标签 */
  /deep/ .el-input {
      height: 28px;
      line-height: 28px;
      .el-input__inner[type="number"] {
        padding: 0 3px 0 3px !important;

        box-sizing: border-box;
        width: 100%;
        height: 28px;
        line-height: 28px;
      }
    }
  /deep/ .el-input__inner{
    padding:0px!important;
  }
  /deep/ .el-input__suffix{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top:2px;
    box-sizing: border-box;
  }
</style>
